import React, { CSSProperties, useCallback, useEffect, useState } from 'react';
import { Theme, useMediaQuery } from '@material-ui/core';
import { useDataProvider, useVersion } from 'react-admin';
import sub from 'date-fns/sub';

import TotalClientsCard from './TotalClientsCard';
import TotalActiveTraineesCard from './TotalActiveTraineesCard';
import ClientsChart from './ClientsChart';
import { Client } from '../../interfaces/client.interface';
import { Stats } from '../../interfaces/stats.interface';
import { apiUrl, getUserConfig, httpClient } from '../../providers/data.provider';
import TotalActiveCoachesCard from './TotalActiveCoachesCard';
import TotalActiveMarathonsCard from './TotalActiveMarathonsCard';
import TotalCoachesCreatedCard from './TotalCoachesCreatedCard';

const styles = {
	flex: { display: 'flex' },
	flexColumn: { display: 'flex', flexDirection: 'column' },
	leftCol: { flex: 1, marginRight: '0.5em' },
	rightCol: { flex: 1, marginLeft: '0.5em' },
	singleCol: { marginTop: '1em', marginBottom: '1em' }
};

const Spacer = () => <span style={{ width: '1em' }}/>;
const VerticalSpacer = () => <span style={{ height: '1em' }}/>;

export const Dashboard = () => {
	const dataProvider = useDataProvider();
	const version = useVersion();
	const [clients, setClients] = useState([] as Client[]);
	const [stats, setStats] = useState<Stats>();

	const isXSmall = useMediaQuery((theme: Theme) =>
		theme.breakpoints.down('xs')
	);
	const isSmall = useMediaQuery((theme: Theme) =>
		theme.breakpoints.down('md')
	);

	const fetchClients = useCallback(async () => {
		const { data } = await dataProvider.getList<Client>(
			'clients',
			{
				filter: {
					'from__createdAt': sub(new Date(), { days: 30 })
				},
				sort: { field: '_createdAt', order: 'DESC' },
				pagination: { page: 1, perPage: 1000 }
			}
		);

		console.log(data);

		setClients(data);
	}, [dataProvider]);

	const fetchStats = useCallback(async () => {
		const { json } = await httpClient(`${apiUrl}/organizations/${getUserConfig()?.user?.organizationId}/stats`);

		setStats(json.data);
	}, []);

	useEffect(() => {
		fetchClients();
	}, [version, fetchClients]);

	useEffect(() => {
		fetchStats();
	}, [version, fetchStats]);

	return isXSmall ? (
		<div>
			<div style={styles.flexColumn as CSSProperties}>
				<TotalClientsCard value={stats?.totalNumberOfClients?.toString()}/>
				<VerticalSpacer/>
				<TotalActiveCoachesCard value={stats?.numberOfActiveCoaches}/>
				<VerticalSpacer/>
				<TotalActiveCoachesCard value={stats?.numberOfActiveCoaches}/>
				<VerticalSpacer/>
				<TotalActiveMarathonsCard value={stats?.numberOfActiveMarathons}/>
				<VerticalSpacer/>
				<TotalCoachesCreatedCard value={stats?.numberOfCoachesCreated}/>
				<VerticalSpacer/>
				<VerticalSpacer/>
				<ClientsChart clients={clients}/>
			</div>
		</div>
	) : isSmall ? (
		<div style={styles.flexColumn as CSSProperties}>
			<div style={styles.singleCol}>
			</div>
			<div style={styles.flex}>
				<TotalClientsCard value={stats?.totalNumberOfClients?.toString()}/>
				<Spacer/>
				<TotalActiveTraineesCard value={stats?.numberOfActiveTrainees}/>
			</div>
			<VerticalSpacer/>
			<div style={styles.flex}>
				<TotalActiveCoachesCard value={stats?.numberOfActiveCoaches}/>
				<Spacer/>
				<TotalCoachesCreatedCard value={stats?.numberOfCoachesCreated}/>
				<Spacer/>
				<TotalActiveMarathonsCard value={stats?.numberOfActiveMarathons}/>
			</div>
			<div style={styles.singleCol}>
				<ClientsChart clients={clients}/>
			</div>
		</div>
	) : (
		<>
			<div style={styles.flex}>
				<div style={styles.leftCol}>
					<div style={styles.flex}>
						<TotalClientsCard value={stats?.totalNumberOfClients?.toString()}/>
						<Spacer/>
						<TotalActiveTraineesCard value={stats?.numberOfActiveTrainees}/>
						<Spacer/>
						<TotalActiveCoachesCard value={stats?.numberOfActiveCoaches}/>
						<Spacer/>
						<TotalCoachesCreatedCard value={stats?.numberOfCoachesCreated}/>
						<Spacer/>
						<TotalActiveMarathonsCard value={stats?.numberOfActiveMarathons}/>
					</div>
					<div style={styles.singleCol}>
						<ClientsChart clients={clients}/>
					</div>
				</div>
			</div>
		</>
	);
};
